import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { CageBlockEntity } from '../../entities/BlockEntity';
import { app } from '../../app';
import { getMatch2AssetPath } from '../../util/assets';

export type CageBlockEffectOptions = {
  entity: CageBlockEntity;
};

// Cage is the id of bubble overlay block
export class CageBlockEffect {
  private readonly scene: GameScene;
  private readonly entity: CageBlockEntity;

  constructor(scene: GameScene, options: CageBlockEffectOptions) {
    this.scene = scene;
    this.entity = options.entity;
  }

  public async animateBreak() {
    const particles = app.particles.create({
      textures: [getMatch2AssetPath('cage/block.cage.particle.png')],
      rate: 0,
      limit: 10,
      emitterDuration: 0,
      duration: 1,
      velocity: [
        { x: 0, y: 0 },
        { x: 0, y: 300 },
      ],
      scale: [
        { x: 0.7, y: 0.7 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 300], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: -1000 } },
        { type: 'scale', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();
    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }
}
